import { render, staticRenderFns } from "./modelDeatail.vue?vue&type=template&id=034f0a74&scoped=true"
import script from "./modelDeatail.vue?vue&type=script&lang=js"
export * from "./modelDeatail.vue?vue&type=script&lang=js"
import style0 from "./modelDeatail.vue?vue&type=style&index=0&id=034f0a74&prod&lang=scss"
import style1 from "./modelDeatail.vue?vue&type=style&index=1&id=034f0a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f0a74",
  null
  
)

export default component.exports